import React from 'react';
import PropTypes from 'prop-types';
import {Image as ImageUI} from '@spothero/ui/backlog';
import withConfig from 'config/withConfig';

const Image = ({cloudinaryCloudName, ...props}) => {
    return <ImageUI cloudinaryCloudName={cloudinaryCloudName} {...props} />;
};

Image.propTypes = {
    cloudinaryCloudName: PropTypes.string,
};

export default withConfig(['cloudinaryCloudName'])(Image);
